import React, { Component, PropTypes } from 'react'
import styles from './DropDownSelect.css'
import CSSModules from 'react-css-modules'
// import Icon from '../Icon'

@CSSModules(styles, { allowMultiple: true })
export default class DropDownSelect extends Component {
  static propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number
    })),
    value: PropTypes.number
  }

  constructor (props) {
    super(props)

    this._handleChange = this._handleChange.bind(this)
  }

  resetSelect() {
    this.refs.select.value = ''
    this.props.onChange(parseInt(this.refs.select.value))
  }

  _renderOptions () {
    const { options } = this.props

    const optionsWithEmptyOption = [
      { label: 'Välj konto', value: '' },
      ...options
    ]

    return optionsWithEmptyOption.map((option, i) => (
      <option
        key={`DropDownSelect-option-${i}`}
        onClick={this._handleChange.bind(this, option.value, option.label)}
        value={option.value}>
        {option.label}
      </option>
    ))
  }

  _handleChange (event) {
    this.props.onChange(parseInt(event.target.value))
  }

  render () {
    return (
      <div styleName="dropdown-select-container">
        {this.props.label && <h2>{this.props.label}</h2>}
        <div styleName="wrapper">
          <select
            onChange={this._handleChange}
            ref="select"
            styleName="select"
            value={this.props.value ? this.props.value : ''}>
            {this._renderOptions()}
          </select>
          <div styleName="select__arrow" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DropDownSelect/DropDownSelect.js